import type { ComponentProps } from 'react';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';
import { formatPostalCodeForDisplay } from '@makemydeal/dr-shared-ui-utils';
import { TextInput } from '../TextInput/TextInput';

const DIGIT = /\d/;
const FIVE_DIGITS = [DIGIT, DIGIT, DIGIT, DIGIT, DIGIT];
const NINE_DIGITS = [...FIVE_DIGITS, '-', DIGIT, DIGIT, DIGIT, DIGIT];
const NON_DIGIT = /\D/g;

const POSTAL_CODE_MASKING = {
    guide: false,
    mask: (rawValue: string) => (rawValue.length <= 5 ? FIVE_DIGITS : NINE_DIGITS)
};

export const PostalCodeField = ({ value, onChange, ...props }: ComponentProps<typeof TextInput>) => {
    const isMaskEnabled = useSelector(featureToggleSelectors.isPostalCodeDigitsOnlyValidationEnabled);
    const [displayValue, setDisplayValue] = useState(formatPostalCodeForDisplay(value as string));

    useEffect(() => {
        setDisplayValue((current) =>
            current.replace(NON_DIGIT, '') === String(value ?? '') ? current : formatPostalCodeForDisplay(value as string)
        );
    }, [value]);

    if (!isMaskEnabled) return <TextInput {...props} value={value} onChange={onChange} />;

    return (
        <TextInput
            {...props}
            value={displayValue}
            masking={POSTAL_CODE_MASKING}
            onChange={(event) => {
                setDisplayValue(event.target.value);
                onChange?.({ ...event, target: { ...event.target, value: event.target.value.replace(NON_DIGIT, '') } });
            }}
        />
    );
};
